"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _excluded = ["classes", "className", "size", "color", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 20,
  sm: 50,
  md: 100,
  lg: 200,
  xl: 500
};

var styles = function styles(theme) {
  return {
    root: {
      textAlign: 'center'
    },
    circle: {
      animation: 'loaderRot 1s linear infinite',

      /* IE 10+, Fx 29+ */
      WebkitAnimation: 'loaderRot 1s linear infinite',

      /* Safari 4+ */
      MozAnimation: 'loaderRot 1s linear infinite',

      /* Fx 5+ */
      transformOrigin: 'center'
    },
    '@keyframes loaderRot': {
      from: {
        transform: 'rotate(0deg)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    },
    stop1primary: {
      stopColor: theme.palette.primary.dark
    },
    stop2primary: {
      stopColor: theme.palette.grey.light
    },
    stop1secondary: {
      stopColor: theme.palette.secondary.dark
    },
    stop2secondary: {
      stopColor: theme.palette.grey.medium
    }
  };
};

var Loader = function Loader(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      size = _ref.size,
      color = _ref.color,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var dimension = sizes[size] || '100%';
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _clsx["default"])(classes.root, className),
    style: {
      height: dimension,
      width: dimension
    }
  }, rest), /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "myGradient"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "25%",
    className: classes["stop1".concat(color)]
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "75%",
    className: classes["stop2".concat(color)]
  }))), /*#__PURE__*/_react["default"].createElement("circle", {
    className: classes.circle,
    cx: "10",
    cy: "10",
    r: "5",
    fill: "none",
    stroke: "url(#myGradient)"
  })), children);
};

Loader.defaultProps = {
  classes: {},
  size: 'sm',
  color: 'primary',
  children: null
};
Loader.propTypes = {
  classes: _propTypes["default"].object,
  className: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(['primary', 'secondary']),
  size: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  children: _propTypes["default"].any
};

var _default = (0, _reactJss["default"])(styles)(Loader);

exports["default"] = _default;